export default abstract class Str {
    public static randomString(length: number): string {
        if (length <= 0) {
            return '';
        }

        const data: Uint8Array = new Uint8Array(length > 4 ? length * 0.8 : length);
        crypto.getRandomValues(data);
        let result: string = btoa(String.fromCharCode(...data));
        result = result.replace(/[/=+]/g, '');
        if (result.length < length) {
            result += this.randomString(length - result.length);
        }

        return result.substring(0, length);
    }

    public static queryString(query: Record<string, string>): string {
        return new URLSearchParams(query).toString();
    }
}
